import {Adresse} from "./Adresse";

export class Agency {
	// Properties in list
	ORG_ID!: number | null;
	ORG_LIBELLE!: string;
	ORG_DESC!: string;
	ORG_TYPE!: number | null;
	ORG_SIMU_TOTAL!: number | null;
	ORG_SIMU_USED!: number | null;
	ADR_ID!: number | null
	ADR_ADRESSE_1!: string | null;
	ADR_CP!: string | null;
	ADR_VILLE!: string | null;
	PYS_CODE!: string | null;

	// Other Properties
	[key: string]: any;

	constructor(
		ORG_ID: number | null = null,
		ORG_LIBELLE: string = "",
		ORG_DESC: string = "",
		ORG_TYPE: number | null = null,
		ORG_SIMU_TOTAL: number | null = null,
		ORG_SIMU_USED: number | null = null,
		ADR_ID: number | null = null,
		ADR_ADRESSE_1: string | null = null,
		ADR_CP: string | null = null,
		ADR_VILLE: string | null = null,
		PYS_CODE: string | null = null
	) {
		this.ORG_ID = ORG_ID;
		this.ORG_LIBELLE = ORG_LIBELLE;
		this.ORG_DESC = ORG_DESC;
		this.ORG_TYPE = ORG_TYPE;
		this.ORG_SIMU_TOTAL = ORG_SIMU_TOTAL;
		this.ORG_SIMU_USED = ORG_SIMU_USED;
		this.ADR_ID = ADR_ID;
		this.ADR_ADRESSE_1 = ADR_ADRESSE_1;
		this.ADR_CP = ADR_CP;
		this.ADR_VILLE = ADR_VILLE;
		this.PYS_CODE = PYS_CODE;
	}
}
